import { css, unsafeCSS } from 'lit';
import {sbkCoreBreakpointMd} from '@/tokens/variables.js'

const breakpointMd = unsafeCSS(`${sbkCoreBreakpointMd}`);

export const facet7 = css` 
    :host {
        
    }
    
    .image__facet-7 {
        ::slotted(img), ::slotted(picture) {
            object-fit: cover;
            clip-path: polygon( 99.963% 100%,36.914% 100%,36.914% 100%,30.929% 99.516%,25.25% 98.116%,19.955% 95.876%,15.118% 92.872%,10.816% 89.18%,7.125% 84.877%,4.122% 80.038%,1.883% 74.74%,0.483% 69.06%,0% 63.072%,0% 0%,63.086% 0%,63.086% 0%,69.071% 0.484%,74.75% 1.884%,80.045% 4.124%,84.882% 7.128%,89.184% 10.82%,92.875% 15.123%,95.878% 19.962%,98.117% 25.26%,99.517% 30.94%,100% 36.928%,100% 100% );
            aspect-ratio: 1;
            width: 100%;
            height: auto;
            z-index: 1;
        }
        .image-shapes-7 {
            display: block;
        }
        .image-shapes-7--crop-mobile {
            display: none;
        }
    }

    .image__facet-7--crop-mobile {
        ::slotted(img), ::slotted(picture) {
            aspect-ratio:  4 / 3;
            clip-path: polygon( 0% 0%,0% 62.922%,0% 62.922%,0.42% 68.933%,1.637% 74.637%,3.584% 79.957%,6.195% 84.815%,9.403% 89.136%,13.143% 92.843%,17.348% 95.859%,21.952% 98.109%,26.889% 99.514%,32.092% 100%,100% 100%,100% 21.542%,100% 21.542%,99.934% 19.148%,99.74% 16.796%,99.42% 14.49%,98.98% 12.235%,98.423% 10.034%,97.754% 7.893%,96.976% 5.814%,96.093% 3.803%,95.11% 1.864%,94.031% 0%,0% 0% );
        }
        .image-shapes-7 {
            display: none;
        }
        .image-shapes-7--crop-mobile {
            display: block;
        }
        @media screen and (min-width: ${breakpointMd}) {
            ::slotted(img), ::slotted(picture) {
                aspect-ratio: 1;
                clip-path: polygon( 99.963% 100%,36.914% 100%,36.914% 100%,30.929% 99.516%,25.25% 98.116%,19.955% 95.876%,15.118% 92.872%,10.816% 89.18%,7.125% 84.877%,4.122% 80.038%,1.883% 74.74%,0.483% 69.06%,0% 63.072%,0% 0%,63.086% 0%,63.086% 0%,69.071% 0.484%,74.75% 1.884%,80.045% 4.124%,84.882% 7.128%,89.184% 10.82%,92.875% 15.123%,95.878% 19.962%,98.117% 25.26%,99.517% 30.94%,100% 36.928%,100% 100% );
            }
            .image-shapes-7 {
                display: block;
            }
            .image-shapes-7--crop-mobile {
                display: none;
            }
        }
    }
    
    .image-shapes-7 {
        position: absolute;
        top: 0.8%;
        left: -15.05%;
        width: 139%;
        height: auto;
        z-index: 2;
    }

    .image-shapes-7--crop-mobile {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: auto;
        z-index: 2;
    }
`;